export default __webpack_public_path__ + "static/MediaMainBanner-d7c33a36b762c7b1f224405007c5c8bd.webp";